function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4785 7.42604C23.2775 7.42604 27.9785 12.1271 27.9785 17.926C27.9785 23.725 23.2775 28.426 17.4785 28.426C11.6795 28.426 6.97847 23.725 6.97847 17.926C6.97847 12.1271 11.6795 7.42604 17.4785 7.42604Z",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8627 14.0971L19.5428 14.698C21.3134 15.3483 23.1858 13.9527 23.0548 12.0981C22.9685 10.9173 22.8354 9.62828 22.5798 8.28399C22.089 5.66567 21.3627 3.43794 20.6196 1.67332C20.4324 1.24023 19.855 1.13672 19.529 1.4778C18.2192 2.8744 16.7643 4.71109 15.3945 6.99588C14.6878 8.16766 14.1152 9.33018 13.6242 10.4074C12.8512 12.1333 14.1281 14.0602 16.0143 14.0654L17.7985 14.0856L17.8627 14.0971Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9449 21.5637L17.1852 21.2687C15.3276 20.941 13.7308 22.6451 14.187 24.4476C14.4803 25.5946 14.8388 26.8399 15.3276 28.118C16.2727 30.6086 17.3807 32.6732 18.4235 34.279C18.6842 34.6723 19.2708 34.6723 19.5315 34.279C20.5744 32.6732 21.6824 30.6086 22.6274 28.118C23.1163 26.8399 23.4747 25.5946 23.768 24.4476C24.2243 22.6123 22.6274 20.941 20.7699 21.2687L19.0101 21.5637H18.9449Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7634 20.2898L14.0567 18.5202C14.3826 16.6522 12.688 15.0464 10.8956 15.5052C9.755 15.8001 8.51664 16.1606 7.24569 16.6522C4.76896 17.6026 2.71589 18.7168 1.11906 19.7655C0.727995 20.0277 0.727995 20.6175 1.11906 20.8797C2.71589 21.9284 4.76896 23.0426 7.24569 23.993C8.51664 24.4846 9.755 24.8451 10.8956 25.14C12.7205 25.5988 14.3826 23.993 14.0567 22.125L13.7634 20.3554V20.2898Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2401 20.6133L15.2624 19.1058C14.2196 17.5328 11.9384 17.5 10.8956 19.1058C10.2438 20.0889 9.59205 21.2032 9.00546 22.4485C7.83227 24.8408 7.08274 27.0365 6.6265 28.9045C6.49615 29.3961 6.9198 29.8221 7.40862 29.7238C9.26616 29.3961 11.5148 28.8062 13.9589 27.7903C15.2299 27.2659 16.3704 26.7088 17.4133 26.1189C19.0427 25.2013 19.1731 22.8745 17.7066 21.7275L16.2727 20.6133H16.2401Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5418 19.2697L19.0753 20.3183C17.5436 21.3998 17.6088 23.7266 19.2056 24.7097C20.2159 25.3324 21.3565 25.9223 22.5948 26.5122C25.0064 27.5936 27.2224 28.2818 29.08 28.6751C29.5688 28.7734 29.9924 28.3474 29.8947 27.8558C29.5036 25.9878 28.8192 23.7594 27.7438 21.3343C27.1898 20.0889 26.5706 18.9419 25.9515 17.926C24.9738 16.3202 22.6926 16.2547 21.5846 17.7949L20.5418 19.2697Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4868 18.4176L21.5846 20.22C21.6824 22.088 23.6377 23.3006 25.3323 22.4813C26.3751 21.9569 27.5157 21.3343 28.6563 20.5805C30.8723 19.1386 32.6321 17.5983 33.9682 16.2547C34.3267 15.8942 34.1963 15.3043 33.7401 15.1404C31.9477 14.485 29.7317 13.8296 27.1246 13.4363C25.7559 13.2397 24.485 13.1414 23.3118 13.1086C21.4543 13.0431 20.1507 14.9766 20.8351 16.7135L21.5194 18.3848L21.4868 18.4176Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.143 14.8435L15.0229 13.4343C15.9354 11.9596 15.0881 10.026 13.3609 9.76387C12.2855 9.60001 11.1123 9.50169 9.84135 9.43615C7.29945 9.37061 5.08343 9.63278 3.35624 9.9605C3.03036 10.026 2.86742 10.4193 3.06295 10.6815C4.07319 12.1562 5.47449 13.8931 7.33204 15.63C8.24451 16.482 9.15699 17.2358 10.0369 17.8912C11.4382 18.9071 13.3935 18.1206 13.7846 16.4493L14.143 14.8435Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1507 16.069C20.444 16.4295 20.7373 16.79 21.0306 17.1832C21.9431 18.3303 23.768 18.1664 24.4524 16.8555C24.876 16.0362 25.2997 15.1186 25.6907 14.1027C26.3425 12.4314 26.7336 10.8583 26.9617 9.51471C27.092 8.82651 26.4403 8.26939 25.7885 8.46602C24.485 8.85928 23.0185 9.44916 21.4216 10.3012C20.4766 10.7928 19.6293 11.3499 18.8472 11.8743C17.6414 12.7263 17.7066 14.5288 18.9449 15.3153L20.1507 16.069Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7367 16.1313C18.8019 15.6725 18.8345 15.1809 18.8996 14.7221C19.0626 13.2474 17.6613 12.0676 16.26 12.5264C15.3801 12.7886 14.435 13.1491 13.4574 13.6079C11.8279 14.3289 10.4918 15.1482 9.38381 15.9019C8.79722 16.2952 8.8624 17.18 9.48158 17.5077C10.6874 18.1304 12.1212 18.7858 13.8158 19.3101C14.8261 19.6379 15.8037 19.8673 16.7162 20.0311C18.1501 20.2933 19.3885 18.9824 19.0626 17.5405L18.7367 16.1641V16.1313Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.927 17.5088C17.4708 17.6072 17.0145 17.7382 16.5583 17.8366C15.1244 18.197 14.5052 19.9012 15.3851 21.0809C15.9391 21.8347 16.5909 22.5884 17.3404 23.3749C18.5788 24.653 19.8172 25.7017 20.8926 26.4882C21.4466 26.8815 22.2287 26.5538 22.3265 25.8656C22.522 24.5219 22.6198 22.9161 22.5546 21.1137C22.522 20.0322 22.3916 19.0491 22.2613 18.1315C22.0332 16.6568 20.3712 15.9686 19.1328 16.7551L17.9596 17.5088H17.927Z",
  fill: "#63C430",
  stroke: "#07911E",
  strokeLinejoin: "round"
});

var SvgBush = function SvgBush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bush.8c82b5a1.svg";
export { ForwardRef as ReactComponent };